import logo from "../images/logo.png";
import "./Header.css";
import Search from "./Search.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Header() {
  return (
    <header className="header">
      <Container>
        <Row>
          <Col xs={12} md={4} lg={3}>
            <img className="logo" src={logo} />
          </Col>
          {window.location.pathname != "/" ? (
            <Col className="d-flex align-self-center" xs={12} md={8} lg={7}>
              <Search />
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Container>
    </header>
  );
}

export default Header;
